<template>
    <div>
            As partes, entre si, definem como justo e acordado o que se segue: 
            <br>
            A Revenda declara conhecer e aceitar sem ressalvas ou restrições todos os termos e condições estabelecidos neste instrumento, especialmente a cláusula sobre o Foro para dirimir as dúvidas sobre o presente contrato. A concordância com novos termos ou alterações dos existentes, bem como em condições expressas nas consultas ou nos pedidos de compra que vier a realizar, também poderá se dar através de meios eletrônicos da Aldo, pelos quais a Revenda reconhece como sendo legítimos. 
            <br>
            <br>
            1. Condições Gerais
            <br>
            1.1 - O programa de relacionamentos lucrativos Aldo Crazy Card, daqui por diante designado simplesmente “Aldo Crazy Card”, é uma iniciativa da Descarbonize Soluções S/A, daqui por diante designada ALDO com sede na Av. Advogado Horácio Raccanello Filho, 1836 - Vila Nova, Maringá, Estado do Paraná, inscrita no CNPJ/MF sob nº 81.106.957/0001-19, beneficiando indistintamente ao(s) participante(s) que cumprir(em) ao regulamento aqui disposto; 
            <br>
            1.2 - Poderá participar do Aldo Crazy Card toda e qualquer revenda de informática e solar, pessoa jurídica cadastrada como cliente na Aldo e que preencha os requisitos exigidos pelo programa; 
            <br>
            1.3– A Aldo informa que as únicas pessoas autorizadas a assinar ou firmar quaisquer tipos de acordo em seu nome são os sócios-proprietários da Aldo; no caso da não observância desta regra, a Aldo ficará desobrigada de cumprir quaisquer tipos de acordos ou contratos firmados; a Revenda declara estar ciente e plenamente de acordo com este termo sem ressalvas ou restrições, e aceitá-lo como legítimo e de direito da Aldo; 
            <br>
            1.4 A CONDIÇÃO PARA PARTICIPAR DO PROGRAMA É A ACEITAÇÃO INCONDICIONAL E SEM RESSALVAS DO PRESENTE REGULAMENTO;
            <br>
            <br>
            2. Participação
            <br>
            2.1 - Toda compra, exceto de ativo imobilizado, efetuada na Aldo pelos participantes do programa gerarão pontos denominados “Aldolares”; 
            <br>
            2.2 - O Aldolar é uma “moeda” própria do Aldo Crazy Card e o seu símbolo é “A$”; 
            <br>
            <div style="color: red;">2.3 - Prazo de UPGRADE E DOWNGRADE é mensal</div>
            <div style="color: red;">2.4 - O Aldo Crazy Card possui três categorias de classificação. São elas: </div>
            <div style="color: red;">- Aldo Crazy Card Verde: Será classificado nesta categoria o participante que tiver realizado de R$ 15.000,00 a R$ 56.000,00 em compras faturadas no mês vigente. </div>
            <div style="color: red;">- Aldo Crazy Card Amarelo: Será classificado nesta categoria o participante que tiver realizado de R$ 56.000,01 a R$ 100.000,00 em compras faturadas no mês vigente. </div>
            <div style="color: red;">- Aldo Crazy Card Azul: Será classificado nesta categoria o participante que tiver realizado acima de R$ 100.000,01 em compras faturadas no mês vigente. </div>
            2.5 - Cada categoria apresentará elementos de diferenciação entre os cartões. São eles:
            <br>
            <br>                        
            <div class="table-responsive">
                <table class="table table-condensed text-center">
                    <thead>
                        <tr>
                            <th class="text-center">Categoria</th>
                            <th class="text-center">Política de descontos no preço</th>
                            <th class="text-center">Política de frete CIF para RMA</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text-left">Aldo Crazy Card Verde</td>
                            <td>Desconto 0,5%</td>
                            <td>Não</td>
                        </tr>
                        <tr>
                            <td class="text-left">Aldo Crazy Card Amarelo</td>
                            <td>Desconto 1%</td>
                            <td>Sim</td>
                        </tr>
                        <tr>
                            <td class="text-left">Aldo Crazy Card Azul</td>
                            <td>Desconto 1,5%</td>
                            <td>Sim</td>
                        </tr>
                    </tbody>
                    <tfoot class="tab-inf-footer">
                        <tr>
                            <td colspan="3" style="text-align:left">
                                * Consultar valor mínimo para frete CIF de RMA. 
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            2.6 - A Aldo se reserva o direito de mudar, a qualquer tempo e sob qualquer pretexto, a política de classificação dos cartões bem como sua política de descontos e/ou fretes; 
            <br>
            <div style="color: red;">2.7 - O upgrade de categoria (quando o cliente sobe no nível do cartão) será mensal mediante os valores necessários indicados no ponto 2.4 tendo como base o no mês atual; O downgrade (queda de categoria no nível do cartão) de categoria será realizada mensalmente, com base nos valores necessários para permanecer na categoria, período base será o mês atual; </div>
            A Aldo se reserva o direito de mudar a política de upgrade (cliente recebe cartão com melhores benefícios) e downgrade (cliente recebe cartão com menos benefícios) a qualquer tempo. 
            <br>
            2.8 - Os participantes do Aldo Crazy Card terão ou não bônus de valor do A$ dependendo de sua categoria.
            <br>
            <br>
                <div class="table-responsive">
                <table class=" table table-condensed text-center">
                    <thead>
                        <tr>
                            <th class="text-center" style="width:60%">Categoria</th>
                            <th class="text-center">Real</th>
                            <th class="text-center">Valor do A$</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text-left">Aldo Crazy Card Verde</td>
                            <td>R$1,00</td>
                            <td>A$1,00</td>
                        </tr>
                        <tr>
                            <td class="text-left">Aldo Crazy Card Amarelo</td>
                            <td>R$1,00</td>
                            <td>A$1,00 + 5% de Bônus</td>
                        </tr>
                        <tr>
                            <td class="text-left">Aldo Crazy Card Azul</td>
                            <td>R$1,00</td>
                            <td>A$1,00 + 15% de Bônus</td>
                        </tr>
                    </tbody>
                        <tfoot class="tab-inf-footer">
                        <tr>
                            <td colspan="3" style="text-align:left">
                                A Aldo se reserva do direito de alterar a política de pontos, bônus e/ou valor do A$ a qualquer tempo e sob qualquer pretexto;  
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            2.9 - Os boletos bancários que excederem 4 (quatro) dias de atraso do dia do vencimento, gerarão 20% de penalização (decréscimo) no valor dos A$ do mesmo; 
            <br>
            No caso de devolução das mercadorias por parte da revenda, será debitado do valor de Aldolares integral, para devolução total ou parcial; 
            <br>
            A Aldo se reserva o direito de alterar a política de penalizações a qualquer tempo. 
            <br>
            2.10 - O Aldo Crazy Card, assim como seus benefícios, são nominais e intransferíveis e deverão ser devolvidos em caso de solicitação por parte do programa. O participante deverá apresentar o Aldo Crazy Card sempre que este for solicitado; 
            <br>
            2.11 - No caso de encerramento da pessoa jurídica participante, a respectiva conta será encerrada e os A$ cancelados automaticamente; 
            <br>
            2.12 – Os A$ serão válidos por períodos de 12 meses (período aquisitivo), sendo o início do primeiro período aquisitivo contado a partir da data de emissão da nota fiscal/geração dos A$; 
            <br>
            2.13 - Os A$ são pessoais e intransferíveis. É vetado ao participante qualquer tipo de comercialização dos A$ sob pena de serem tomadas medidas judiciais cabíveis; 
            <br>
            2.14 - O Aldo Crazy Card se reserva o direito de estabelecer promoções e benefícios de caráter eventual, por tempo determinado, podendo cancelá-los e/ou alterá-los a qualquer momento, sem aviso prévio; 
            <br>
            2.15 - Os A$ somente terão validade caso a revenda não possuir débitos, de qualquer natureza, vencidos ou pendentes com a Aldo; 
            <br>
            2.16 - Caso a revenda participante de umas das categorias deste programa (verde, amarelo ou azul) no processo de downgrade mensal, retornar ou ir para a categoria SEM CARTÃO (menos de R$ 15.000,00 em compras mensais), todos os ALDOLARES acumulados no programa até então, serão invalidados/expirados automaticamente. 
            <br>
            <br>
            3. Conta Aldo Crazy Card 
            <br>
            3.1 - A Aldo disponibilizará, através do site do programa www.aldo.com.br/crazycard , informações sobre a movimentação da conta do participante. Poderá, também, a seu exclusivo critério, utilizar outros meios para a divulgação dessas informações. 
            <br>
            3.2 - O participante que não acumular A$(Aldolar) no mês terá sua conta considerada inativa e deixará de receber, com regularidade, comunicações do Programa Aldo Crazy Card;
            <br>
            3.3 - Em hipótese alguma será permitida a transferência de A$ entre contas de diferentes participantes do Aldo Crazy Card, seja empresas filiais ou não; 
            <br>
            3.4 – Os A$ perderão validade em contas consideradas inativas; 
            <br>
            <br>
            4. Política de benefícios
            <br>
            4.1 – O participante deverá acessar o site do programa ( www.aldo.com.br/crazycard ) e seguir as orientações de acordo com as políticas de benefícios para resgate dos mesmos; 
            <br>
            4.2 - Os prêmios Aldo Crazy Card são intransferíveis e não endossáveis; 
            <br>
            4.3 – Usufruirão da política de benefícios, os participantes do programa que estejam em dia com suas obrigações junto à Aldo Componentes Eletrônicos; 
            <br>
            4.4 - Os participantes poderão trocar os A$ a qualquer momento de acordo com a política de benefícios. 
            <br>
            4.5 - A utilização dos Aldolares para verbas de marketing e divulgação deverá ser obrigatoriamente para promoção de produtos adquiridos na Descarbonize Soluções S/A e deverão seguir criteriosamente o GUIA DE BENEFÍCIOS ALDO CRAZY CARD
            <br>
            4.6 - É obrigatório o envio de PROJETO para solicitações de Verbas de marketing e/ou contratações de serviços de terceiros (Como pintura, fachada de loja etc.). O projeto deverá conter todos os detalhes sobre a utilização da verba (orçamentos, layouts etc) e será analisado pela Aldo que poderá aprová-lo ou recusá-lo. O envio do mesmo será feito via site, bastando seguir as instruções do GUIA DE BENEFÍCIOS ALDO CRAZY CARD;
            <br>
            4.7 - Uma vez aprovado, projeto será enquadrado em um grau de elegibilidade de reembolso de 30% a 100% do valor solicitado.
            <br>
            4.8 - Não é possível iniciar uma nova solicitação de benefícios enquanto uma solicitação anterior encontrar-se pendente / em aprovação; 
            <br>
            4.9 - O pagamento de solicitação de Aldolares destinadas a verbas de marketing e divulgação somente serão efetivadas mediante confecção de projeto para utilização da verba, aprovação prévia do mesmo pela Aldo e, após a execução, envio de todos os documentos comprovatórios; 
            <br>
            4.10 - Projetos não executados dentro do período máximo estipulado pelo regulamento serão cancelados automaticamente no mês vigente*. 
            *Uma vez cancelados não voltarão em vigor, sendo necessário criar um novo processo de solicitação através do site.
            <br>
            <br>
            5 - Considerações Finais
            <br>
            5.1 – A efetivação de quaisquer pedidos na Aldo pelo participante do programa Aldo Crazy Card estará sempre sujeita à analise de crédito; 
            <br>
            5.2 - A Aldo se reserva o direito de suspender ou cancelar o respectivo cartão em caráter temporário ou definitivo, como também não mais aceitar que o participante utilize os prêmios da política de benefícios. 
            <br>
            5.3 - A Aldo se reserva também o direito de suspender ou cancelar o Programa de Relacionamentos Lucrativos Aldo Crazy Card a qualquer momento ou de efetuar qualquer alteração no regulamento sem aviso prévio. O participante poderá também, a qualquer tempo, cancelar sua participação mediante comunicação expressa e devolução de seu cartão; 
            <br>
            5.4 - Se, por alguma razão legal ou proibição decorrente de regulamentação governamental o Programa Aldo Crazy Card não puder ter seu regulamento ou benefícios cumpridos na totalidade, a Aldo estará isenta de responsabilidade perante os participantes e os parceiros; 
            <br>
            5.5 - A Aldo não tem qualquer responsabilidade pelos serviços prestados ou produtos oferecidos por terceiros, cabendo ao participante o entendimento direto com os mesmos; 
            <br>
            5.6 - Os casos omissos não previstos neste regulamento serão tratados diretamente entre o participante e a administração do Aldo Crazy Card; 
            <br>
            5.7 - A participação no presente programa implicará a integral aceitação das condições de sua realização, expressas no presente Regulamento, disponível no site www.aldo.com.br/crazycard e no Contrato de Revenda padrão; 
            <br>
            5.8 - O programa tem início no dia 05 de março de 2007 e terá a sua validade por tempo indeterminado de acordo com a política comercial da Aldo; 
            <br>
            5.9 - Fica eleito o foro da comarca de Maringá, com exclusão de qualquer outro, por mais privilegiado que seja, para solução de quaisquer dúvidas referentes a este regulamento; 
            <br>
            5.10 – Em caso de litígio entre as partes a Aldo fica desobrigada ao pagamento dos honorários sucumbenciais; 
            <br>
            5.11 - O rompimento da relação comercial, por qualquer hipótese, não implica em pagamentos de quaisquer indenizações que sejam, para quaisquer das partes, sejam de ordem material ou moral; 
            <br>
            5.12 - A rescisão contratual se dará independentemente de notificação, interpelação ou aviso de qualquer natureza, e terá efeito imediato, o que, no entanto, não prejudicará o direito da Aldo de perseguir, extra ou judicialmente, reparação pelos danos que eventualmente lhe forem causados, ou de utilizar-se de outras medidas que julgarem adequadas; 
            <br>
            5.13 - Estes Termos e Condições são estabelecidos em benefício das partes e obriga sucessores a qualquer título; 
            <br>
            5.14 - Na hipótese de qualquer condição ou cláusula destes Termos e Condições ser considerada nula judicialmente, esta nulidade não afetará qualquer outra cláusula ou disposição e as partes efetuarão a substituição por outra válida, legal e executável; 
            <br>
            5.15 - A tolerância da Aldo quanto ao descumprimento de qualquer das obrigações assumidas neste instrumento não implica na novação ou renúncia de direito, podendo a referida obrigação vir a ser exigida em qualquer momento; 
            <br><br>
			<div style="color: red;">As regras destacadas em vermelho terá validade à partir do dia 01/01/2019</div>
			<br><br>
            Aldo Componentes Eletrônicos
        </div>
</template>
<script>
export default {
    name : 'CrazyRegulament'
}
</script>

